module.exports = __webpack_public_path__ + "img/paynowLogo.f1040dc7.png";